import { Input } from 'antd';
import { RouteName } from 'config/constants/route.constants';
import { OrderByType } from 'config/constants/search.constants';
import { CatalogTranscription } from 'config/constants/transcription.constant';
import NavigationUtils from 'config/utils/navigation.util';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Search } from 'store/models/search.model';
import { SearchSlice } from 'store/slices/search.slice';
import styles from './style.module.scss';

type InputSearchProps = {
  search: Search;
};

const InputSearch: React.FC<InputSearchProps> = ({ search = {} }) => {
  const { searchTerm = '', page = 1, orderBy = OrderByType.DESC } = search;
  const [searchTermState, setSearchTermState] = useState<string>(searchTerm);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleOnSearch = (searchTerm: string): void => {
    if (searchTerm.length > 0) {
      dispatch(SearchSlice.resetSearchStore());
      dispatch(SearchSlice.refreshSearchStore({ searchTerm: searchTerm }));

      const searchQueryString = queryString.stringify({ searchTerm: searchTerm, page, orderBy }, NavigationUtils.queryStringOptions);

      const searchPath = `${RouteName.SEARCH}?${searchQueryString}`;
      navigate(searchPath, NavigationUtils.navigateOptions);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchTermState(value);
  };

  useEffect(() => {
    if (searchTerm && searchTerm.length > 0) setSearchTermState(searchTerm);
  }, [searchTerm]);

  return (
    <div className={styles['searcn-input-container']}>
      <Input.Search
        placeholder={CatalogTranscription.SEARCH_INPUT_PLACEHOLDER}
        loading={search.isFetching}
        value={searchTermState}
        onSearch={() => handleOnSearch(searchTermState)}
        onChange={handleChange}
      />
    </div>
  );
};

export default InputSearch;
